import Vue from 'vue';
import httpClient from '@/config';

// Read the current session for each request, including after sign-in or renewal.
const authorization = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
});

export const locationEvents = new Vue();

export const listLocations = async (params = {}) => {
  const { data } = await httpClient.get('/locations', { ...authorization(), params });
  return data;
};

export const saveLocation = async (entry) => {
  const fields = {
    name: entry.name.trim(),
    path: entry.path.trim(),
    contact: (entry.contact || '').trim(),
    notes: (entry.notes || '').trim(),
    kind: entry.kind,
  };
  const response = entry.id
    ? await httpClient.put(`/locations/${entry.id}`, {
      ...fields, revision: entry.revision,
    }, authorization())
    : await httpClient.post('/locations', fields, authorization());
  locationEvents.$emit('changed');
  return response.data;
};

export const duplicateLoad = async (id) => {
  const { data } = await httpClient.post(`/loads/${id}/duplicate`, {}, authorization());
  return data;
};

export const featureError = (error, fallback) => {
  const status = error.response?.status;
  if (status === 401) return 'Your session has expired. Sign in again to continue.';
  if (status === 403) return 'An active administrator account is required.';
  if (status === 409) return error.response.data?.message || 'This record changed. Refresh before saving.';
  if (status === 404) return 'This record is no longer available. Refresh and try again.';
  if (status === 400) {
    const message = error.response.data?.message;
    return Array.isArray(message) ? message.join(' ') : message || fallback;
  }
  return fallback;
};
